<template>
    <div class="minimal-hero">
        <!-- 质感背景层 -->
        <div class="texture-background">
            <div class="gradient-mesh"></div>
            <div class="dynamic-grain"></div>
        </div>

        <!-- 内容容器 -->
        <div class="content-container">
            <!-- 动态文字排版 -->
            <h1 class="typography-master">
                <span class="line">Global Supply Chain</span>
                <span class="line">Intelligent solutions</span>
            </h1>

            <!-- 分割线动画 -->
            <div class="divider-animation">
                <div class="active-line"></div>
            </div>

            <div class="data-elegance">
                <div class="data-flow">
                    <div class="metric-item">
                        <div class="metric-line"></div>
                        <animated-number
                            :value="150"
                            class="number"
                            :duration="2000"
                        />
                        <div class="metric-label">Boundless Link</div>
                        <div class="metric-unit">Eliminate digital boundaries of regions</div>
                    </div>

                    <div class="metric-item">
                        <div class="metric-line"></div>
                        <animated-number
                            :value="98"
                            class="number"
                            :duration="1600"
                        />
                        <div class="metric-label">Entropy reduction evolution</div>
                        <div class="metric-unit">Building an orderly business ecosystem</div>
                    </div>

                    <div class="metric-item">
                        <div class="metric-line"></div>
                        <animated-number
                            :value="24"
                            class="number"
                            :duration="1200"
                        />
                        <div class="metric-label">Emerging value</div>
                        <div class="metric-unit">Create synergies beyond expectations</div>
                    </div>
                </div>
            </div>

            <!-- 智能按钮 -->
            <button class="material-button" @click="navigateTo('/about')">
                About Us
                <div class="hover-fill"></div>
            </button>
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
    mounted() {
        this.initAnimations()
    },
    methods: {
        initAnimations() {
            // 文字逐行显现
            gsap.from('.line', {
                duration: 1.2,
                y: 40,
                opacity: 0,
                stagger: 0.2,
                ease: 'expo.out'
            })

            // // 分割线流动效果
            // gsap.to('.active-line', {
            //     start: 'top 80%',
            //     duration: 4,
            //     scaleX: 1,
            //     transformOrigin: 'left center',
            //     repeat: -1,
            //     ease: 'none'
            // })

            // 材质按钮交互
            const buttons = document.querySelectorAll('.material-button')
            buttons.forEach(btn => {
                btn.addEventListener('mousemove', this.handleButtonHover)
                btn.addEventListener('mouseleave', this.resetButtonState)
            })
        },

        handleButtonHover(e) {
            const { left, top } = e.target.getBoundingClientRect()
            const xPos = e.clientX - left
            const yPos = e.clientY - top

            gsap.to(e.target.querySelector('.hover-fill'), {
                x: xPos,
                y: yPos,
                duration: 0.3,
                ease: 'sine.out'
            })
        },

        resetButtonState(e) {
            gsap.to(e.target.querySelector('.hover-fill'), {
                x: '50%',
                y: '50%',
                duration: 0.6,
                ease: 'elastic.out(1, 0.5)'
            })
        },
        navigateTo(path, params = {}) {
            this.$navigate.path(path, {
                query: params.query,
                params: params.params
            });
        }
    }
}
</script>

<style lang="scss">
.minimal-hero {
    height: 100vh;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent; /* 移除原有背景 */
    backdrop-filter: blur(10px); /* 添加玻璃效果 */
    border: 1px solid rgba(197, 164, 126, 0.1); /* 统一边框 */
    will-change: backdrop-filter, transform;
}

.texture-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #0A1A2F;
}


.content-container {
    position: relative;
    z-index: 2;
    text-align: center;
    padding: 0 2rem;
}

.typography-master {
    font-size: 3rem;
    font-weight: 350;
    line-height: 1.1;
    margin-bottom: 2rem;
    color: rgba(255, 255, 255, 0.95);

    .line {
        display: block;
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
    }
}

.divider-animation {
    width: 240px;
    height: 1px;
    background: rgba(255, 255, 255, 0.1);
    margin: 2rem auto;
    overflow: hidden;

    .active-line {
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, #C5A47E, transparent);
        transform: scaleX(0);
    }
}

.data-elegance {
    position: relative;
    margin: 4rem 0;

    .data-flow {
        display: flex;
        justify-content: center;
        gap: 6rem;
        padding: 2rem 0;
        border-top: 1px solid rgba(197, 164, 126, 0.1);
        border-bottom: 1px solid rgba(197, 164, 126, 0.1);

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 3rem;
        }
    }

    .metric-item {
        position: relative;
        text-align: center;

        .metric-line {
            position: absolute;
            left: 50%;
            top: -2rem;
            width: 1px;
            height: 30px;
            background: linear-gradient(
                    to bottom,
                    transparent 0%,
                    #C5A47E 50%,
                    transparent 100%
            );
            opacity: 0.6;
            transition: height 0.3s ease;
        }

        &:hover .metric-line {
            height: 40px; // 悬浮时线条延伸
        }

        .number {
            font-size: 3.2rem;
            font-weight: 300;
            color: #C5A47E;
            letter-spacing: -0.03em;
            margin-bottom: 0.4rem;
        }

        .metric-label {
            font-size: 1rem;
            color: rgba(255, 255, 255, 0.8);
            //text-transform: uppercase;
            letter-spacing: 0.15em;
            margin-bottom: 0.2rem;
        }

        .metric-unit {
            font-size: 0.85rem;
            color: #C5A47E;
            font-family: monospace;
        }
    }
}

.material-button {
    position: relative;
    padding: 1.2rem 2.4rem;
    background: transparent;
    border: 1px solid rgba(197, 164, 126, 0.3);
    color: #C5A47E;
    font-size: 1rem;
    letter-spacing: 0.1em;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease;
    //font-weight: 600;

    .hover-fill {
        position: absolute;
        width: 120px;
        height: 120px;
        background: radial-gradient(circle, rgba(197, 164, 126, 0.1) 0%, transparent 70%);
        transform: translate(-50%, -50%);
        pointer-events: none;
    }

    &:hover {
        border-color: rgba(197, 164, 126, 0.6);
        background: rgba(10, 26, 47, 0.2);
    }
}

@media (max-width: 768px) {
    .typography-master {
        font-size: 2.5rem;
    }

    .data-elegance {
        flex-direction: column;
        gap: 2rem;
    }
}

.divider-animation {
  width: 240px;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 2rem auto;
  overflow: hidden; // 关键属性

  .active-line {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, #C5A47E, transparent);
    transform-origin: left center;

    /* 精准对应 GSAP 参数 */
    animation: gsap-clone 4s linear infinite;
    transform: scaleX(0); // 初始状态
  }
}

/* 帧对帧复刻 GSAP 动画 */
@keyframes gsap-clone {
  0% {
    transform:
      scaleX(0)
      translateX(0%); // 初始位置
  }
  100% {
    transform:
      scaleX(1)
      translateX(5%); // 保持原位展开 (模拟 GSAP 纯缩放)
  }
}
</style>
